export default [

    {
        path: '/research/discovery/requests',
        name: 'research-discovery-grid',
        component: () => import('@/views/research/discovery/Requests.vue'),
    },
    {
        path: '/research/review/processes',
        name: 'research-review-grid',
        component: () => import('@/views/research/review/Grid.vue'),
    },
    {
        path: '/research/review/processes/:id',
        name: 'research-review-card',
        component: () => import('@/views/research/review/Card.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/research/discovery/requests/:id',
        name: 'research-discovery-card',
        component: () => import('@/views/research/discovery/RequestCard.vue'),
        props: (route) => {
            return route.params;
        }
    },

    {
        path: '/sent-requests',
        name: 'sent-requests',
        component: () => import('@/views/request/sent/Requests.vue'),
    },
    {
        path: '/sent-requests/:id',
        name: 'sent-request',
        component: () => import('@/views/request/sent/RequestV2.vue'),
        props: (route) => {
            return route.params;
        }
    },

    {
        path: '/received-requests',
        name: 'received-requests',
        component: () => import('@/views/request/received/Requests.vue'),
    },
    {
        path: '/received-requests/:id',
        name: 'received-request',
        component: () => import('@/views/request/received/RequestV2.vue'),
        meta: {
            // RequestV2 selects the manifest or legacy translation group after loading the request.
            translationGroups: [],
        },
        props: route => ({
            ...route.params,
            workflowEngineSwitcherEnabled: true,
        }),
    },
    {
        path: '/received-requests/:id/forward',
        name: 'forward-request',
        component: () => import('@/views/request/ForwardRequest.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/requests/email-options',
        name: 'request-email-options',
        component: () => import('@/views/request/RequestEmailOptionsStep.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/received-requests/:id/forward/confirmation',
        name: 'forward-request-confirmation',
        component: () => import('@/views/request/ForwardConfirmation.vue'),
        props: (route) => {
            return route.params;
        }
    },
    {
        path: '/supplier/follow-up/:id',
        name: 'supplier-follow-up',
        component: () => import('@/views/supply-chain/supplier/FollowUpCard.vue'),
        props: (route) => {
            return route.params;
        }
    },
];
